

<template>
  <div>
    <div v-loading="loading">
      <el-form :model="form" class="u-mt5">
        <el-form-item v-if="!this.isInsuredAudience" class="line-height-3">
          <el-select v-model="selectedGroupComputedValue" class="group__selection">
            <el-option  v-for="group in selectedGroupList"
                        :selected="form.selected_group==group.id"
                        :value="group.id"
                        :label="group.name"
                        :key="group.id">
            </el-option>
          </el-select>
          <span class="u-pl2" v-if="totalAudience >= 0" >
            {{totalAudienceComputed}} users selected
          </span>
        </el-form-item>

        <el-form-item label="Message Title*">
          <el-input type="text" class="u-mt1 message__title" v-model="form.title" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item class="u-mb2" label="Message Details*">
          <el-input type="textarea" class="u-mt1 message__details" v-model="form.details" maxlength="1900" show-word-limit></el-input>
        </el-form-item>

        <div class="u-text--sm u-mb4">* Denotes a required field</div>

        <el-form-item v-if="!this.isInsuredAudience" label="Broadcast Name (optional: pick a friendly name, for example: Smoke Detector check)">
          <el-input type="text" class="u-mt1 message__campaign" v-model="form.campaign_name"></el-input>
        </el-form-item>

        <div class="channels u-mt4 u-mb3">
          <div class="u-text--sm u-mb3">Choose the channels to deliver this message</div>
          <el-checkbox v-for="channel in getAllowedChannels()" :key="channel.name" v-model="channel.selected" @change="channelSelected()">
            {{channel.displayName | capitalize_all}}
          </el-checkbox>
        </div>

        <el-row class="campaign-schedule u-mb4">
          <el-col :xs="{span: 24, offset: 0}" :sm="{span: 12, offset: 0}">
            <div class="send-in-future">
              <el-checkbox class="u-mt1" v-model="form.send_in_future">Send at specific date/time</el-checkbox>
              <el-popover
                      placement="top-start"
                      width="500"
                      trigger="hover">
                <icon class="u-mr1 help__icon" slot="reference" scale="1" :name="'question-circle'"></icon>
                <div class="setting-help">
                  <div class="help__description">
                    <span v-html="start_help"/>
                  </div>
                </div>
              </el-popover>
              <div v-if="form.send_in_future">
                <div class="u-text--light u-text--sm u-mt3">Choose the future date and time when the message should be delivered</div>
                <el-date-picker v-if="form.send_in_future" format="MM/dd/yyyy hh:mm A" type="datetime" class="u-mt1" v-model="form.scheduled_at">
                </el-date-picker>
              </div>
            </div>
          </el-col>
          <el-col v-if="messageCenterSelected" :xs="{span: 24, offset: 0}" :sm="{span: 12, offset: 0}">
            <div class="terminate-on-date">
              <el-checkbox class="u-mt1" v-model="form.should_terminate_on_date">Dismiss date/time</el-checkbox>
              <el-popover
                      placement="top-start"
                      width="500"
                      trigger="hover">
                <icon class="u-mr1 help__icon" slot="reference" scale="1" :name="'question-circle'"></icon>
                <div class="setting-help">
                  <div class="help__description">
                    <span v-html="dismiss_help"/>
                  </div>
                </div>
              </el-popover>
              <div v-if="form.should_terminate_on_date">
                <div class="u-text--light u-text--sm u-mt3">Choose the date and time when the message will automatically be dismissed from Notifications</div>
                <el-date-picker v-if="form.should_terminate_on_date" format="MM/dd/yyyy hh:mm A" type="datetime" class="u-mt1" v-model="form.terminate_on">
                </el-date-picker>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="emailSelected" class="u-mb5">
          <el-col>
            <input type="file" ref="uploadAttachment" style="display:none" @change="afterFileSelected"/>
            <el-button icon="el-icon-plus" @click="addAttachment">Add Attachment</el-button>
            <h3 v-if="selectedAttachments.length > 0" class="u-mt3">Included attachments ({{selectedAttachments.length}}):</h3>
            <el-row >
              <el-col
                  :span="8"
                  :xs="{span: 24, offset: 0}"
                  v-for="(attachment, index) in selectedAttachments"
                  :key="index"
                  class="u-mt3"
                  :offset="index % 2 ? 2 : 0">
                <el-card >
                  <div class="single-attachment">
                    <span class="single-attachment__name">{{attachment.filename}} ({{attachment.size | humanFilesize}})</span>
                    <el-button type="danger" size="mini" icon="el-icon-delete" circle  @click="removeSelectedAttachment(attachment)"></el-button>
                  </div>
              </el-card>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <div v-if="errors.length" class="u-text--danger">
          <div>Please correct the following error(s):</div>
          <ul>
            <li  v-for="error in errors">{{ error }}</li>
          </ul>
        </div>

        <el-button v-loading="isTransmissionInProgress" :disabled="isTransmissionInProgress" type="primary" class="u-mt2" @click="send_button_click">Send</el-button>

      </el-form>
    </div>

    <div v-if="dialogTableVisible" class="outer-dialog" ></div>
    <div v-if="dialogTableVisible" class="dialog-user-screen">
      <div class="table-info">
        <div class="table-users-data__title">Select Individual Users</div>
        <div><el-input placeholder="Search Users" v-model="searchUsers"></el-input></div>
      </div>
      <div class="table-users-data__table-col">
        <div></div>
        <div @click="sortUsers" class="table-users-data__sort">
          <span>Name</span>
          <span><i :class="`el-icon-caret-${ sorting.byNameAcs ? 'bottom' : 'top'}`"></i></span>
        </div>
        <div>User Login</div>
        <div>Registration Date</div>
      </div>
      <div v-if="usersArray && usersArray.length > 0">
        <el-checkbox-group v-model="checkedUsers" @change="selectionChange" class="table-users-data">
          <el-checkbox v-for="user in usersArray" :label="user.user_id"  :key="user.user_id">
            <span class="table-users-data__item">{{ user.name }}</span>
            <span class="table-users-data__item">{{ user.username }}</span>
            <span class="table-users-data__item">{{ user.registered_date }}</span>
          </el-checkbox>
        </el-checkbox-group>
        <div class="dialog-footer">
          <el-button @click="closeDialog(false)">Cancel</el-button>
          <el-button type="primary" @click="closeDialog(true)">Confirm</el-button>
        </div>
      </div>
      <div v-if="usersArray.length === 0" class="table-users-data__no-data">No data</div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import axios from 'axios'
  import config from '@/config'
  import _ from 'lodash'


  export default {
    name: 'ba-send-insured-message',
    props: [
      'messageAudience',
      'companyId',
      'insuredId',
    ],
    async mounted () {
      this.loading = true
      await this.getAllAvailableChannels()
      await this.getSelectedUsersList()
      await this.loadTotalAudience('all')
      this.loading = false
    },
    data () {
      return {
        form: {
          title: '',
          details: '',
          campaign_name: '',
          send_in_future: false,
          scheduled_at: null,
          should_terminate_on_date: false,
          terminate_on: null,
          selected_group: 'all',
        },
        maxMessageLength: 200,
        totalAudience: -1,
        channels: [],
        errors: [],
        start_help: 'If this is set, the message will be held until this time. ' +
                     'We may not send it exactly at this time but it will be sent at the next possible processing time.',
        dismiss_help: 'This only applies to Notifications in the application.  If the user has not already ' +
                       'dismissed the message it will be dismissed automatically at or near this time.',
        messageCenterSelected: false,


        selectedGroupList: [
          {id: 'all', name: 'All enrolled users'},
          {id: 'eDelivery', name: 'All users not enrolled in eDelivery'},
          {id: 'individuals', name: 'Selected individual users'}],
        loading: false,
        dialogTableVisible: false,
        selectedIndividualUsers: [],
        savedCurrentUsers: [],
        checkedUsers: [],
        searchUsers: '',
        sorting: {
          isActivated: false,
          byNameAcs: false,
        },
        selectedAttachments: [],
        isTransmissionInProgress: false,
      }
    },
    computed: {
      ...mapState('shared', ['users']),
      selectedGroupComputedValue: {
        get () {
          return this.form.selected_group
        },
        set (updatedSettingValue) {
          this.form.selected_group = updatedSettingValue
          this.selectGroupChanged()
        },
      },
      insured () {
        return this.users[this.insuredId]
      },
      selectedGroupName: {
        get: function () {
          if (this.isInsuredAudience) {
            return ''
          }

          let group = _.find(this.selectedGroupList, group => {
            return group.id === this.form.selected_group
          })
          return group.name.charAt(0).toLowerCase() + group.name.substring(1)
        }
      },
      isInsuredAudience: {
        get: function () {
          return this.messageAudience === 'insured'
        }
      },
      usersArray: {
        get: function () {
          let users = _.values(this.users)
          users = users.filter(el => {
            return el.name.toLowerCase().includes(this.searchUsers.toLowerCase())
          })
          if (this.sorting.isActivated) {
            users = this.sorting.byNameAcs ? this.sortUsersList(users, 'asc') : this.sortUsersList(users, 'desc')
          }
          return users
        },
      },
      emailSelected () {
        let result = false
        this.channels.forEach(element => {
          if (element.name === 'email' && element.selected) {
            result = true
          }
        })
        return result
      },
      totalAudienceComputed () {
        if (this.form.selected_group === 'individuals') {
          return this.selectedIndividualUsers.length
        }

        return this.totalAudience
      },
    },
    methods: {
      ...mapActions('shared', ['getAllInsureds']),
      sortUsers () {
        this.sorting.isActivated = true
        this.sorting.byNameAcs = !this.sorting.byNameAcs
      },
      getDisplayName (name) {
        if (name === 'notification') {
          return 'app ' + name
        } else if (name === 'push') {
          return name + ' notification'
        } else if (name ==='sms') {
          return 'text message'
        } else {
          return name.replace('_', ' ')
        }
      },
      getAllowedChannels () {
        if (!this.isInsuredAudience || this.isTextAvailable()) {
          return this.channels
        }

        return this.channels.filter(function (item) {
          return item.name !== 'sms'
        })
      },
      isTextAvailable () {
        if (!this.isInsuredAudience) {
          return true
        }
        return this.insured.consent_to_text
      },
      async getAllAvailableChannels () {
        let url = config.url + `/company/${this.companyId}/insured-messages/channels/`
        let response = await axios.get(url)
        let arrayOfChannels = response.data.channels
        this.channels.length = 0
        this.channels = arrayOfChannels.map(name => ({
          name: name,
          displayName: this.getDisplayName(name),
          selected: true
        }))
        this.selectedChannelsChange()
      },
      async getSelectedUsersList () {
        await this.getAllInsureds(this.companyId)
      },
      selectGroupChanged () {
        let selectedGroup = this.form.selected_group
        if (selectedGroup === 'individuals') {
          this.dialogTableVisible = true
          this.selectedIndividualUsers = this.savedCurrentUsers
        } else {
          this.selectedIndividualUsers = []
          this.loadTotalAudience(selectedGroup)
        }
      },
      closeDialog (saveData) {
        let isEqualUserList = _.isEqual(this.savedCurrentUsers, this.selectedIndividualUsers)
        if (!saveData) {
          if (!isEqualUserList) {
            this.selectedIndividualUsers = this.savedCurrentUsers
            this.checkedUsers = this.savedCurrentUsers.map(x => x.user_id)
          }
        } else {
          this.savedCurrentUsers = this.selectedIndividualUsers
        }
        this.searchUsers = ''
        this.dialogTableVisible = false
      },
      sortUsersList (arr, order) {
        return _.orderBy(arr, ['name'], order ? [`${order}`] : ['asc'])
      },
      selectionChange (selectedItems) {
        this.checkedUsers = selectedItems
        this.selectedIndividualUsers = this.usersArray.filter(x => this.checkedUsers.filter(y => x.user_id === y).length > 0)
        this.sortUsersList(this.selectedIndividualUsers)
      },
      addAttachment () {
        this.$refs.uploadAttachment.click()
      },
      removeSelectedAttachment (attachment) {
        let index = this.selectedAttachments.indexOf(attachment)
        if (index !== -1) {
          this.selectedAttachments.splice(index, 1)
        }
      },
      afterFileSelected () {
        let file = this.$refs.uploadAttachment.files[0]

        let reader = new FileReader()
        reader.onloadend = () => {
          let filename = file.name
          // strip metadata such as: data:image/png;base64,{......}
          let base64 = reader.result.split(',')[1]
          let size = file.size
          this.selectedAttachments.push({filename, base64, size})
        }

        if (file) {
          reader.readAsDataURL(file)
        }
      },
      isValidForm () {
        this.errors = []

        if (!this.form.title) {
          this.errors.push('Title cannot be empty')
        }

        if (!this.form.details) {
          this.errors.push('Details cannot be empty')
        }

        if (this.form.send_in_future) {
          let clickMessage = 'If you want to send the message immediately, uncheck `send at specific date` checkbox.'
          if (this.form.scheduled_at != null && this.form.scheduled_at < Date.now()) {
            this.errors.push('You cannot schedule event in the past. ' + clickMessage)
          }

          if (this.form.scheduled_at == null) {
            this.errors.push('You must enter a send date.  ' + clickMessage)
          }
        }

        if (this.form.should_terminate_on_date) {
          let clickMessage = 'If you don\'t want to automatically dismiss the message, uncheck `Dismiss date/time` checkbox.'
          if (this.form.terminate_on != null && this.form.terminate_on < Date.now()) {
            this.errors.push('You cannot schedule event in the past. ' + clickMessage)
          }

          if (this.form.terminate_on == null) {
            this.errors.push('You must enter a dismiss date.  ' + clickMessage)
          }
        }

        if (this.channels.every(_ => !_.selected)) {
          this.errors.push('You need to select at least one message channel')
        }

        if (this.form.selected_group === 'individuals' && this.selectedIndividualUsers.length === 0) {
          this.errors.push('You have not selected any users')
        }

        return !this.errors.length
      },
      async send_button_click () {
        if (!this.isValidForm()) {
          return
        }
        try {
          let destination = this.selectedGroupName
          let additionalMessage = ''
          let summaryMessageLength = this.form.title.length + this.form.details.length
          let isSelectedPushOption = this.channels.some(el => el.name === 'push' && el.selected)
          if (this.isInsuredAudience) {
            destination = this.insured.name
          }
          if (isSelectedPushOption && summaryMessageLength > this.maxMessageLength) {
            additionalMessage = '<p class="broadcast-msg">Your message exceeds 200 characters. If you continue' +
              ' the message will be truncated when it is delivered as a push notification.</p>'
          }
          let title = this.isInsuredAudience ? 'Message to User' : 'Broadcast Message'
          await this.$confirm(
            '<div>Are you sure you want to send a message to ' + destination + '?' + additionalMessage + '</div>',
            title,
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'Send'
            }
          )
          this.send_now()
        } catch (e) {
          console.error(e)
        }
      },
      url_based_on_recipients () {
        let baseUrl = config.url + `/company/${this.companyId}/`

        if (this.isInsuredAudience) {
          return baseUrl + `insureds/${this.insuredId}/insured-message/`
        } else {
          return baseUrl + `insured-messages/new-campaign/`
        }
      },
      async send_now () {
        try {
          this.isTransmissionInProgress = true
          let url = this.url_based_on_recipients()
          let channels = this.channels.filter(_ => _.selected).map(_ => _.name)
          let users = this.form.selected_group === 'individuals' ? this.selectedIndividualUsers.map(_ => _.user_id) : []
          await axios.post(url, {...this.form, channels: channels, individual_users: users, attachments: this.selectedAttachments})
          this.$notify({
            title: 'Success',
            message: 'The message(s) will be delivered soon',
            type: 'success'
          })
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Failed to send message: ' + e,
          })
        } finally {
          this.$router.back()
          this.isTransmissionInProgress = false
        }
      },
      selectedChannelsChange () {
        let selected = false
        let $this = this
        this.channels.forEach(function (element) {
          if (element.name.indexOf('message') !== -1 || element.name.indexOf('notification') !== -1) {
            if (element.selected === true) {
              selected = true
            } else {
              $this.form.should_terminate_on_date = false
            }
          }
        })
        this.messageCenterSelected = selected
      },
      async loadTotalAudience (selectedGroup) {
        if (this.isInsuredAudience) {
          return
        }
        let url = config.url + `/company/${this.companyId}/insured-messages/audience/`
        let response = await axios.get(url, { params: {
          user_group: selectedGroup
        }})

        this.totalAudience = response.data.total
      },
    },
  }
</script>

<style scoped>
  @media only screen and (max-width: 768px) {
    .terminate-on-date {
      margin-top: 2em;
    }

  }

  .help__icon {
    border-radius: 4px;
    position: relative;
    top: 0.4em;
    color: #455b5f;
    margin: 0 0 3px 10px;
  }

  .help__description {
    white-space: pre-line;
    word-break: normal;
  }

  .group__selection {
    width: 20%
  }
</style>

<style lang="scss">
  .dialog-users {
    margin-top: 5vh !important;
    height: 90vh !important;
    overflow-y: hidden;
    .el-dialog__body {
      height: 78vh;
      overflow-y: scroll;
    }
  }
  .broadcast-msg {
    padding-top: 15px;
  }
</style>

<style lang="scss">
  .dialog-wrapper {
    z-index: 2080;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
  }
  .dialog-user-screen {
    position: absolute;
    background: #FFFFFF;
    top: 10%;
    height: 80%;
    left: 25%;
    width: 60%;
    overflow-y: scroll;
    padding: 0 20px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: .2s;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    z-index: 2030;
  }
  .table-info {
    position: sticky;
    top: 0;
    background: #FFFFFF;
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 40px;
    align-items: center;
    padding: 20px 0;
    z-index: 2100;
  }
  .table-users-data {
    &__title {
      font-size: 22px;
    }
    &__sort {
      cursor: pointer;
    }
    &__no-data {
      padding: 15px 0 15px 40px;
      border: 1px solid #ebeef5;
      font-size: 14px;
      font-weight: 500;
    }
    &__table-col {
      display: grid;
      grid-template-columns: 30px 250px 220px auto;
      grid-gap: 10px;
      border: 1px solid #ebeef5;
      padding: 20px 0;
      background-color: #e7edee;
    }
    & > .el-checkbox {
      padding: 15px;
      display: flex;
      margin-right: 0;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
      .el-checkbox__inner {
        position: relative;
        top: 3px;
      }
      .el-checkbox__label {
        display: grid;
        grid-template-columns: 250px 220px auto;
        grid-gap: 10px;
      }
    }
    &__item {
      padding-right: 10px;
    }
  }
  .dialog-footer {
    padding: 20px 0;
    text-align: right;
    position: sticky;
    bottom: 0;
    background: white;
    z-index: 2030;
  }
  .outer-dialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: .5;
    background: #000;
    z-index: 2015;
  }

  .single-attachment {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .single-attachment__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
